



























































































import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import { BootType } from '@/Citation/BootType';
import buildEntityListComponentMixin from '@/Shared/CommonEntityMixins/EntityListComponentMixin';
import { PaymentMethod, PaymentSource } from '@/Payment/Enums';
import VatsAPI from '@/Shared/VatsAPI';
import { HostedCheckoutRequest } from '@/Payment/HostedCheckoutRequest';
import UserMixin from '@/Shared/UserMixin';
import Five9BootRelease from './Five9BootRelease.vue';
import DirectBootRelease from './DirectBootRelease.vue';
import BootRelease from './DirectBootRelease.vue';
import { ProcessorVariables } from '@/Payment/ProcessorVariables';
import { PaymentResult } from '@/Payment/PaymentResult';
import ReleaseCompletion from '@/Citation/Payment/ReleaseCompletion.vue';

const component = mixins(LocationBasedMixin, buildEntityListComponentMixin<BootType>(), UserMixin).extend({
    name: 'BootRelease',
    components: {
        Five9BootRelease,
        DirectBootRelease,
        BootRelease,
        ReleaseCompletion
    },
    props: {
        transactionIdentifier: {
            type: String,
            required: true
        },
    },
    async beforeMount() {
        const result = await VatsAPI.get<ProcessorVariables>(this.processorVariablesEndpoint);
        this.processorVariables = result.data;

        this.existingBootReleaseId = await VatsAPI.get<string>(
            this.existingCompletedBootReleaseEndpoint,
            { params: { citationTransactionIdentifier: this.transactionIdentifier }})
            .then(response => response.data);

        if (this.successfulHoldAlreadyCompleted) {
            const responseId =
                (await VatsAPI.get<string>(
                    `${this.location}/Payments/HoldRequest/IsCompleted`,
                    {
                        headers: {
                            accept: 'application/json',
                        },
                        params: {
                            requestID: this.existingBootReleaseId
                        }
                    })).data;
            this.receiptId =
                (await VatsAPI.get<PaymentResult>(`${this.location}/Payments/ProcessorResponse/${responseId}`))
                    .data.receiptId!;
        }
    },
    data() {
        return {
            i18nPrefix: 'payment.citationPayment.bootRelease.request',
            releaseCodes: [] as string[],
            requestingHold: false,
            hostedCheckoutRequest: null as HostedCheckoutRequest | null,
            processorVariables: null as ProcessorVariables | null,
            existingBootReleaseId: null as string | null,
            receiptId: null as number | null
        };
    },
    computed: {
        holdChecked(): boolean {
            return this.existingBootReleaseId !== null;
        },
        successfulHoldAlreadyCompleted(): boolean {
            return this.holdChecked && this.existingBootReleaseId!.length > 0;
        },
        anySelfReleasing(): boolean {
            return this.entities.find(item => item.isSelfReleasing) ? true : false;
        },
        canBeginSelfRelease(): boolean {
            return this.holdChecked &&
            !this.successfulHoldAlreadyCompleted &&
            this.anySelfReleasing;
        },
        entityUrls(): string {
            // Payment method doesn't matter for this call; just hardcoding it to something to make it work
            const path = `${this.location}/CitationPayments/${PaymentMethod.Card}/boots/releaseeligible`;
            const querySafeIdentifier = encodeURIComponent(this.transactionIdentifier);
            const query = `?transactionIdentifier=${querySafeIdentifier}`;
            return `${path}${query}`;
        },
        processorVariablesEndpoint(): string {
            return `${this.location}/Payments/ProcessorVariables`;
        },
        existingCompletedBootReleaseEndpoint(): string {
            return `${this.location}/CitationPayments/${PaymentMethod.Card}/boots/ExistingCompletedHoldRequest`;
        },
        useFive9(): boolean {
            return (this.processorVariables?.five9Enabled && this.isInternal) ?? false;
        }
    },
    methods: {
        async beginSelfRelease() {
            this.requestingHold = true;
            const path = `${this.location}/CitationPayments/${PaymentMethod.Card}/Boots/RequestRelease`;
            const query = { transactionIdentifier: this.transactionIdentifier };
            const response = await VatsAPI.post<HostedCheckoutRequest>(`${path}`, {
                paymentMethod: PaymentMethod.Card,
                paymentSource: PaymentSource.CallIn
            },
            {
                params: query
            });

            this.hostedCheckoutRequest = response.data;
        },
        async showSelfReleaseCode() {
            const path = `${this.location}/CitationPayments/${PaymentMethod.Card}/boots/releasecodes`;
            const query = { transactionIdentifier: this.transactionIdentifier };
            try {
                const response = await VatsAPI.get<string[]>(`${path}`, {
                    params: query
                });
                this.releaseCodes = response.data;
            }
            catch (e) {
                if (!e.response || e.response.status !== 401) {
                    const translatedTitle = this.$i18n.t(`${this.i18nPrefix}.releaseCodeLoadFailedTitle`);
                    const translatedMessage = this.$i18n.t(`${this.i18nPrefix}.releaseCodeLoadFailedMessage`);
                    this.$bvToast.toast(translatedMessage.toString(), {
                        title: translatedTitle.toString(),
                        autoHideDelay: 5000
                    });
                    throw e;
                }
            }
        }
    }
});

export default component;
